import React from 'react';
import LegalHeader from './LegalHeader';
import '../../styles/LegalLayout.css';

const LegalLayout = ({ children }) => {
    return (
        <div className="legal-layout">
            <LegalHeader />
            <main className="legal-main">
                {children}
            </main>
            <footer className="legal-footer">
                <div className="legal-footer-content">
                    <span>© 2025 Ferritico AB. All rights reserved.</span>
                    <div className="legal-footer-links">
                        <a href="/privacy-policy">Privacy Policy</a>
                        <a href="/legal">Legal Notice</a>
                        <a href="/">Contact</a>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default LegalLayout;